"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var moment_1 = __importDefault(require("moment"));
var d3_1 = require("d3");
var recharts_1 = require("recharts");
var utls_1 = require("../../utls");
var Dot_1 = require("./Dot");
var Flag_1 = require("./Flag");
var OpacityBar_1 = require("./OpacityBar");
var OpacityCircle_1 = require("./OpacityCircle");
var models_1 = require("./models");
var lodash_1 = require("lodash");
function Graph(_a) {
    var _b = _a.datasets, datasets = _b === void 0 ? [] : _b, hideTooltip = _a.hideTooltip, labels = _a.labels, hideLabels = _a.hideLabels, hideAxis = _a.hideAxis, _c = _a.options, options = _c === void 0 ? {} : _c, _d = _a.mutexLabels, mutexLabels = _d === void 0 ? [] : _d, onZoom = _a.onZoom, onClick = _a.onClick, onDataClick = _a.onDataClick;
    var _e;
    var _f = react_1.useState([]), chart = _f[0], setChart = _f[1];
    var _g = react_1.useState([]), graph = _g[0], setGraph = _g[1];
    var _h = react_1.useState({
        domain: ["dataMin", "dataMax"],
        domainTime: {},
        ticks: [],
        tickFormatter: null,
        labelFormatter: null,
    }), xAxisConfig = _h[0], setXAxisConfig = _h[1];
    var _j = react_1.useState({
        userSelect: "initial",
        allowDataOverflow: false,
        onMouseUp: function (e) { },
        onMouseDown: function (e) { },
        onMouseMove: function (e) { },
    }), zoomConfig = _j[0], setZoomConfig = _j[1];
    var _k = react_1.useState({
        refAreaLeft: null,
        refAreaRight: null,
    }), zoomRef = _k[0], setZoomRef = _k[1];
    var _l = react_1.useState(), lineRef = _l[0], setLineRef = _l[1];
    react_1.useEffect(function () {
        configureXAxis();
    }, [options.range]);
    react_1.useEffect(function () {
        configureData();
    }, [datasets]);
    react_1.useEffect(function () {
        configureZoom();
    }, [onZoom]);
    react_1.useEffect(function () {
        configureZoom();
    }, [zoomRef.refAreaLeft, zoomRef.refAreaRight]);
    function configureData() {
        var graphTypes = [];
        var data = datasets.reduce(function (p, c, i) {
            var _a, _b;
            if (!c.data) {
                return p;
            }
            if (!c.data.length) {
                return p;
            }
            if (!c.label) {
                c.label = i + " ";
            }
            if (!c.key) {
                c.key = c.label;
            }
            if (!c.yAxisId) {
                c.yAxisId = c.key;
            }
            graphTypes.push({
                key: c.key,
                type: c.type,
                unit: c.unit,
                label: c.label,
                yAxidId: c.yAxisId,
                dash: (_a = c.dash) === null || _a === void 0 ? void 0 : _a.join(", "),
                colour: c.color || "#53A2B5",
                opacity: c.opacity || 1,
                hidden: (_b = graph.find(function (g) { return g.key === c.key; })) === null || _b === void 0 ? void 0 : _b.hidden,
            });
            c.data.forEach(function (cc) {
                var _a;
                var timestamp = moment_1.default(cc.timestamp).valueOf();
                p[timestamp] = __assign(__assign({}, p[timestamp]), (_a = {}, _a[c.key + "-data"] = cc, _a.timestamp = timestamp, _a));
                p[timestamp][c.key] = cc.value;
                if (cc.path)
                    p[timestamp][c.key + "-point"] = cc.value;
            });
            return p;
        }, {});
        var chartData = Object.keys(data)
            .sort(function (a, b) { return parseInt(a) - parseInt(b); })
            .map(function (key) { return data[key]; });
        setChart(chartData);
        configureXAxis(chartData);
        setGraph(ensureMutexLabels(graphTypes).sort(function (a, b) { return models_1.DataTypes[b.type] - models_1.DataTypes[a.type]; }));
    }
    function configureXAxis(chartData) {
        if (chartData === void 0) { chartData = chart; }
        var _a, _b;
        var startPoint = (_a = chartData[0]) === null || _a === void 0 ? void 0 : _a.timestamp;
        var endPoint = (_b = chartData[chartData.length - 1]) === null || _b === void 0 ? void 0 : _b.timestamp;
        if (options) {
            // NOTE: To avoid conflict between ranges, below restricts to one option, range or start/end
            if (options.range) {
                switch (options.range.from) {
                    case "start":
                        endPoint = moment_1.default(startPoint).add(options.range.interval).valueOf();
                        break;
                    case "end":
                        startPoint = moment_1.default(endPoint)
                            .subtract(options.range.interval)
                            .valueOf();
                        break;
                    default:
                        startPoint = moment_1.default(options.range.from.valueOf());
                        endPoint = moment_1.default(startPoint).add(options.range.interval);
                }
            }
            else {
                if (options.start) {
                    startPoint = moment_1.default(options.start).valueOf();
                }
                if (options.end) {
                    endPoint = moment_1.default(options.end).valueOf();
                }
            }
        }
        var domain = [
            startPoint ? startPoint : xAxisConfig.domain[0],
            endPoint ? endPoint : xAxisConfig.domain[1],
        ];
        var domainTime = d3_1.scaleTime().domain(domain);
        var timeDiff = moment_1.default(endPoint).diff(startPoint, "days");
        var ticks = d3_1.timeMonth.every(1);
        var formatter = function (tick) { return moment_1.default(tick).format("MMM YYYY"); };
        if (timeDiff > 3 && timeDiff <= 120) {
            ticks = d3_1.timeDay.every(1);
            formatter = function (tick) {
                return moment_1.default(tick).diff(moment_1.default(tick).startOf("month"), "days") === 0
                    ? moment_1.default(tick).format("MMM YYYY")
                    : moment_1.default(tick).format("MMM DD");
            };
        }
        if (timeDiff > 1 && timeDiff <= 3) {
            ticks = d3_1.timeHour.every(8);
            formatter = function (tick) {
                return moment_1.default(tick).diff(moment_1.default(tick).startOf("day"), "hours") === 0
                    ? moment_1.default(tick).format("MMM DD")
                    : moment_1.default(tick).format("HH:mm");
            };
        }
        if (timeDiff === 1) {
            ticks = d3_1.timeHour.every(4);
            formatter = function (tick) {
                return moment_1.default(tick).diff(moment_1.default(tick).startOf("day"), "hours") === 0
                    ? moment_1.default(tick).format("MMM DD")
                    : moment_1.default(tick).format("HH:mm");
            };
        }
        if (timeDiff === 0) {
            timeDiff = moment_1.default(startPoint).diff(endPoint, "minutes");
            if (timeDiff > 1440 / 2) {
                ticks = d3_1.timeHour.every(2);
            }
            else if (timeDiff > 120) {
                ticks = d3_1.timeHour.every(1);
            }
            else if (timeDiff > 60) {
                ticks = d3_1.timeMinute.every(30);
            }
            else if (timeDiff > 30) {
                ticks = d3_1.timeMinute.every(15);
            }
            else {
                ticks = d3_1.timeMinute.every(1);
            }
            formatter = function (tick) {
                return moment_1.default(tick).diff(moment_1.default(tick).startOf("day"), "minutes") === 0
                    ? moment_1.default(tick).format("MMM DD")
                    : moment_1.default(tick).format("HH:mm");
            };
        }
        setXAxisConfig({
            domain: domain,
            domainTime: domainTime,
            ticks: domainTime.ticks(ticks),
            tickFormatter: function (tick) { return formatter(tick); },
            labelFormatter: function (time) { return moment_1.default(time).format("YYYY-MM-DD HH:mm:ss"); },
        });
    }
    function configureZoom() {
        var zoom = onZoom && typeof onZoom === "function";
        if (!zoom) {
            return setZoomConfig({
                userSelect: "initial",
                allowDataOverflow: false,
                onMouseUp: function () { },
                onMouseDown: function () { },
                onMouseMove: function () { },
            });
        }
        setZoomConfig({
            userSelect: "none",
            allowDataOverflow: true,
            onMouseDown: function (e) { return setZoomRef(__assign(__assign({}, zoomRef), { refAreaLeft: e })); },
            onMouseMove: function (e) {
                setLineRef(e);
                if (!zoomRef.refAreaLeft) {
                    return;
                }
                setZoomRef(__assign(__assign({}, zoomRef), { refAreaRight: e }));
            },
            onMouseUp: function () {
                if (zoomRef.refAreaLeft !== zoomRef.refAreaRight &&
                    zoomRef.refAreaRight) {
                    if (zoomRef.refAreaLeft > zoomRef.refAreaRight) {
                        onZoom([zoomRef.refAreaRight, zoomRef.refAreaLeft]);
                    }
                    else {
                        onZoom([zoomRef.refAreaLeft, zoomRef.refAreaRight]);
                    }
                }
                setZoomRef({ refAreaLeft: null, refAreaRight: null });
            },
        });
    }
    function meta(e) {
        if (!e) {
            return;
        }
        var time = xAxisConfig.domainTime.invert(e.chartX);
        var formatTime = moment_1.default(time).valueOf();
        return formatTime;
    }
    function renderLabel(props) {
        if (!props.payload) {
            return null;
        }
        var timestamp;
        var data = Object.entries(props.payload.reduce(function (p, c) {
            if (c.dataKey.includes("-point")) {
                return p;
            }
            if (c.dataKey.includes("-data")) {
                return p;
            }
            var list = Object.keys(c.payload || {}).reduce(function (pp, cc) {
                var _a;
                if (cc.includes("-point")) {
                    return pp;
                }
                if (cc.includes("-data")) {
                    return pp;
                }
                if (cc === "timestamp") {
                    timestamp = (react_1.default.createElement("strong", { key: cc },
                        moment_1.default(c.payload[cc]).format("YYYY-MM-DD HH:mm:ss"),
                        " ",
                        react_1.default.createElement("br", null)));
                    return pp;
                }
                if (cc !== c.dataKey) {
                    return pp;
                }
                return __assign(__assign({}, pp), (_a = {}, _a[cc] = (react_1.default.createElement("div", { key: cc },
                    react_1.default.createElement("span", { style: { color: c.color } },
                        c.name,
                        ":"),
                    " ",
                    c.payload[cc],
                    " ",
                    react_1.default.createElement("br", null))), _a));
            }, {});
            return __assign(__assign({}, p), list);
        }, {})).map(function (_a) {
            var key = _a[0], value = _a[1];
            return value;
        });
        if (!data.length) {
            return;
        }
        return (react_1.default.createElement("div", { style: { color: "white", padding: "1rem" } },
            data,
            timestamp));
    }
    function toggleLabel(indexToBeToggled) {
        setGraph(function (graph) {
            return graph.map(function (node, index) {
                return index === indexToBeToggled ? __assign(__assign({}, node), { hidden: !node.hidden }) : node;
            });
        });
    }
    function ensureMutexLabels(graph) {
        var newGraph = lodash_1.cloneDeep(graph);
        var mutexLabelsIndexes = newGraph.reduce(function (acc, v, index) { return (mutexLabels.includes(v.key) ? __spreadArrays(acc, [index]) : acc); }, []);
        var showingLabels = mutexLabelsIndexes.filter(function (i) { return !newGraph[i].hidden; });
        if (showingLabels.length > 1) {
            mutexLabelsIndexes.forEach(function (labelIndex, i) {
                // Only show the first one
                newGraph[labelIndex].hidden = i !== 0;
            });
        }
        return newGraph;
    }
    function toggleMutexLabel(key, index) {
        var mutexLabelsIndexes = graph.reduce(function (acc, v, index) {
            return mutexLabels.includes(v.key) && v.key !== key ? __spreadArrays(acc, [index]) : acc;
        }, []);
        var newGraph = lodash_1.cloneDeep(graph);
        var isHidden = graph[index].hidden;
        if (isHidden) {
            // Hide all
            mutexLabelsIndexes.forEach(function (i) {
                newGraph[i] = __assign(__assign({}, newGraph[i]), { hidden: true });
            });
            newGraph[index].hidden = false;
            setGraph(newGraph);
        }
        else {
            toggleLabel(index);
        }
    }
    function renderLegend(props) {
        var hideChartData = function (key) {
            var index = graph.findIndex(function (v) { return v.key === key; });
            if (index === -1) {
                console.error("Item should exist in array");
                return;
            }
            var isMutexLabel = mutexLabels === null || mutexLabels === void 0 ? void 0 : mutexLabels.includes(key);
            if (isMutexLabel) {
                toggleMutexLabel(key, index);
            }
            else {
                toggleLabel(index);
            }
        };
        var item = function (key, color, dash, text, hidden) {
            if (hidden === void 0) { hidden = (_a = graph.find(function (v) { return v.key === key; })) === null || _a === void 0 ? void 0 : _a.hidden; }
            var _a;
            return (react_1.default.createElement("div", { key: key, style: {
                    display: "inline-block",
                    marginLeft: "0.5rem",
                    cursor: "pointer",
                }, onClick: function () { return hideChartData(key); } },
                react_1.default.createElement("svg", { width: "30", height: "15", viewBox: "0 0 15 7" },
                    react_1.default.createElement("rect", { width: "15", height: "7", style: {
                            strokeWidth: 2,
                            stroke: color,
                            strokeDasharray: dash,
                            fill: "transparent",
                        } })),
                react_1.default.createElement("span", { style: {
                        color: utls_1.colours.gray_l,
                        marginLeft: ".5rem",
                        position: "relative",
                        top: "-3.5px",
                        textDecoration: hidden ? "line-through" : "none",
                    } }, text)));
        };
        return (react_1.default.createElement("div", { style: { textAlign: "center" } }, (labels === null || labels === void 0 ? void 0 : labels.generate) ? labels.generate().map(function (i) { return item(i.key, i.color, i.dash, i.value); })
            : graph.reduce(function (p, c) {
                return c.type !== "none"
                    ? __spreadArrays(p, [item(c.key, c.colour, c.dash, c.label, c.hidden)]) : p;
            }, [])));
    }
    function handleClick(_a) {
        var dataKey = _a.dataKey, payload = _a.payload;
        if (!onClick) {
            return;
        }
        var data = payload[dataKey + "-data"];
        if (!data) {
            return;
        }
        onClick(__assign({ key: dataKey }, data));
    }
    function handleDataClick(data, key) {
        if (!onDataClick) {
            return;
        }
        onDataClick({ data: data[key + "-data"], key: key });
    }
    return (react_1.default.createElement(recharts_1.ResponsiveContainer, { width: "100%", height: "100%" },
        react_1.default.createElement(recharts_1.ComposedChart, { style: { userSelect: zoomConfig.userSelect }, margin: { top: 0, left: 0, right: 0, bottom: 0 }, data: chart, onMouseUp: zoomConfig.onMouseUp, onMouseDown: function (e) { return zoomConfig.onMouseDown(meta(e)); }, onMouseMove: function (e) { return zoomConfig.onMouseMove(meta(e)); }, onMouseLeave: function () { return setLineRef(null); } },
            react_1.default.createElement(recharts_1.XAxis, { type: "number", dataKey: "timestamp", stroke: utls_1.colours.gray_l, allowDataOverflow: true, ticks: xAxisConfig.ticks, domain: xAxisConfig.domain, scale: xAxisConfig.domainTime, tickFormatter: xAxisConfig.tickFormatter, hide: typeof hideAxis === "object"
                    ? hideAxis.x && !hideAxis.showFirst
                    : hideAxis }),
            react_1.default.createElement(recharts_1.YAxis, { yAxisId: "left", axisLine: false, tickLine: false, orientation: "left", unit: (_e = graph.find(function (g) { return !g.hidden; })) === null || _e === void 0 ? void 0 : _e.unit, stroke: utls_1.colours.gray_l, hide: typeof hideAxis === "object"
                    ? hideAxis.y && !hideAxis.showFirst
                    : hideAxis }),
            react_1.default.createElement(recharts_1.CartesianGrid, { horizontal: false, stroke: (options === null || options === void 0 ? void 0 : options.gridColor) || "#232530" }),
            (typeof hideAxis === "object" ? hideAxis.x : hideAxis) && (react_1.default.createElement(recharts_1.ReferenceLine, { y: 0, yAxisId: "left", alwaysShow: true, stroke: (options === null || options === void 0 ? void 0 : options.gridColor) || "#232530" })),
            react_1.default.createElement(recharts_1.ReferenceLine, { yAxisId: "left", x: lineRef, strokeOpacity: 1, stroke: utls_1.colours.blue }),
            hideTooltip ? null : (react_1.default.createElement(recharts_1.Tooltip, { cursor: false, filterNull: true, content: renderLabel, wrapperStyle: { background: utls_1.colours.main_l }, labelFormatter: xAxisConfig.labelFormatter })),
            hideLabels ? null : (react_1.default.createElement(recharts_1.Legend, { verticalAlign: "top", content: renderLegend, formatter: function (value) { return (react_1.default.createElement("span", { style: { color: utls_1.colours.gray_l } }, value)); } })),
            Object.entries(graph.reduce(function (p, c) {
                var _a;
                if (c.hidden) {
                    return p;
                }
                if (p[c.yAxidId]) {
                    return p;
                }
                return __assign(__assign({}, p), (_a = {}, _a[c.yAxidId] = {
                    width: 40,
                    axisLine: false,
                    tickLine: false,
                    key: c.key,
                    unit: c.unit,
                    orientation: "right",
                    yAxisId: c.yAxidId,
                    stroke: utls_1.colours.gray_l,
                    hide: typeof hideAxis === "object"
                        ? hideAxis.y || hideAxis.showFirst
                        : hideAxis,
                }, _a));
            }, {})).reduce(function (p, _a, index) {
                var key = _a[0], value = _a[1];
                return index === 0
                    ? p
                    : __spreadArrays(p, [react_1.default.createElement(recharts_1.YAxis, __assign({}, value, { hide: value.hide || index > 1 }))]);
            }, []),
            graph
                .filter(function (v) { return !v.hidden; })
                .map(function (graph, index, list) {
                var yAxisId = graph.yAxidId === list[0].yAxidId ? "left" : graph.yAxidId;
                switch (graph.type) {
                    case "area":
                        return (react_1.default.createElement(recharts_1.Area, { type: "linear", strokeWidth: 2, key: graph.key, yAxisId: yAxisId, name: graph.label, connectNulls: true, fill: graph.colour, fillOpacity: graph.opacity, hide: graph.hidden, dataKey: graph.key, stroke: graph.colour, isAnimationActive: false, strokeDasharray: graph.dash, activeDot: { onClick: function (e) { return handleClick(e); } }, dot: function (props) { return react_1.default.createElement(Dot_1.Dot, __assign({}, props, { onClick: handleClick })); }, onClick: function (data) { return handleDataClick(data, graph.key); } }));
                    case "circle":
                        return (react_1.default.createElement(recharts_1.Scatter, { key: graph.key, yAxisId: yAxisId, name: graph.label, fill: graph.colour, fillOpacity: graph.opacity, hide: graph.hidden, dataKey: graph.key, stroke: graph.colour, shape: react_1.default.createElement(OpacityCircle_1.OpacityCircle, { dataKey: graph.key }), isAnimationActive: false, onClick: function (data) { return handleDataClick(data, graph.key); } }));
                    case "bar":
                        return (react_1.default.createElement(recharts_1.Bar, { key: graph.key, yAxisId: yAxisId, name: graph.label, fill: graph.colour, fillOpacity: graph.opacity, dataKey: graph.key, hide: graph.hidden, stroke: graph.colour, shape: react_1.default.createElement(OpacityBar_1.OpacityBar, { dataKey: graph.key }), isAnimationActive: false, strokeDasharray: graph.dash, onClick: function (data) { return handleDataClick(data, graph.key); } }));
                    case "flag":
                        return (react_1.default.createElement(recharts_1.Scatter, { shape: react_1.default.createElement(Flag_1.Flag, { dataKey: graph.key }), legendType: "none", key: graph.key, yAxisId: yAxisId, name: graph.label, fill: graph.colour, hide: graph.hidden, dataKey: graph.key, isAnimationActive: false, onClick: function (data) { return handleDataClick(data, graph.key); } }));
                    default:
                        return (react_1.default.createElement(recharts_1.Line, { type: "monotone", strokeWidth: 2, key: graph.key, yAxisId: yAxisId, name: graph.label, connectNulls: true, dataKey: graph.key, stroke: graph.colour, hide: graph.hidden, isAnimationActive: false, strokeDasharray: graph.dash, activeDot: { onClick: function (e) { return handleClick(e); } }, dot: function (props) { return react_1.default.createElement(Dot_1.Dot, __assign({}, props, { onClick: handleClick })); }, onClick: function (data) { return handleDataClick(data, graph.key); } }));
                }
            }),
            !zoomRef.refAreaLeft || !zoomRef.refAreaRight ? null : (react_1.default.createElement(recharts_1.ReferenceArea, { yAxisId: "left", x1: zoomRef.refAreaLeft, x2: zoomRef.refAreaRight, fill: utls_1.colours.blue, strokeOpacity: 0.3 })))));
}
exports.Graph = Graph;
//# sourceMappingURL=Graph.js.map